module.exports = __webpack_public_path__ + "static/Yum_Food_Website-0d7a21e26e300dbbe9c9525d91360411.png";